import { Inject, Injectable, Optional } from '@angular/core';
import { Product, ProductScope } from '@spartacus/core';
import { CurrentProductService, JSONLD_PRODUCT_BUILDER, JsonLdBuilder, SchemaBuilder } from '@spartacus/storefront';
import { Observable, combineLatest, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

/**
 * В отличие от спартакуского ProductSchemaBuilder тут добавлено получение продукта
 * вместе со скопом аттрибутов (для бота), так как в аттрибутах содержится бренд
 */
@Injectable({
  providedIn: 'root',
})
export class CustomProductSchemaBuilder implements SchemaBuilder {
  constructor(
    private currentProduct: CurrentProductService,
    @Optional()
    @Inject(JSONLD_PRODUCT_BUILDER)
    protected builders: JsonLdBuilder<Product>[],
  ) {}

  build(): Observable<any> {
    return this.currentProduct.getProduct(this.getProductScopes()).pipe(
      switchMap((product: Product) => {
        if (product) {
          return combineLatest(this.collect(product)).pipe(map((res: PlainObject[]) => Object.assign({}, ...res)));
        }

        return of({});
      }),
    );
  }

  protected collect(product: Product): Observable<any>[] {
    if (!product || !product.code) {
      return [];
    }
    const builders = this.builders ? this.builders.map((builder) => builder.build(product)) : [];

    return [
      of({
        '@context': 'http://schema.org',
        '@type': 'Product',
      }),
      ...builders,
    ];
  }

  private getProductScopes(): ProductScope[] {
    return [ProductScope.DETAILS, ProductScope.ATTRIBUTES];
  }
}
